import { getYQFromStatementId } from '..';

export const sortStatementIdsByLatestFirst = (a: string, b: string): number => {
    const yearAndQuarterA = getYQFromStatementId(a);
    const yearAndQuarterB = getYQFromStatementId(b);

    if (yearAndQuarterA === null || yearAndQuarterB === null) {
        return 0;
    }

    if (yearAndQuarterA < yearAndQuarterB) {
        return 1;
    }

    if (yearAndQuarterA > yearAndQuarterB) {
        return -1;
    }

    return 0;
};
